import {Component, OnInit} from '@angular/core';
import {UserService,ScrollService} from '../../../api/';
import {User} from '../../../../models/';
import {Router, ActivatedRoute} from '@angular/router';
import {BlockUI, NgBlockUI} from 'ng-block-ui';

@Component({
    selector: 'notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {
    public model: User;
    public notificationList: Array<any> = [];
    private billingFailedName = "";
    private billingOccurredName = "";
    private newSignUpName = "";
    private playistItemPlayedName = "";
    verified: boolean = false;
    @BlockUI() blockUI: NgBlockUI;
    public onlineOffline1: boolean = navigator.onLine;

    constructor(private scrollService:ScrollService,private userService: UserService, private router: Router, private route: ActivatedRoute) {
        window.addEventListener('online', () => {this.onlineOffline1 = true; });
        window.addEventListener('offline', () => {this.onlineOffline1 = false});
        this.model = new User();
    }

    submitNotification() {
        if(this.onlineOffline1) {
            this.userService.saveNotification(this.model).subscribe((res) => {
                this.router.navigate(['/billing-profile']);
            }, (err) => {
            });
            this.blockUI.start('Loading please wait...');
            setTimeout(() => {
            }, 1000);
        }
    }

    getUserProfileData() {
        if(this.onlineOffline1) {
            this.userService.getUserProfileData().subscribe((profileData) => {
                this.model.notification_type = profileData.profile.notification_type;
                this.model.notifications_frequency = profileData.profile.notifications_frequency;
                // to check if other steps are already filled
                const status = localStorage.getItem('status');
                if(status > profileData.profile.status) {
                    this.model.status = status;
                } else {
                    this.model.status = profileData.profile.status;
                }
                localStorage.setItem('status', this.model.status);
            }, (err) => {
                console.log(err);
            });
        }
    }

    getNotificationList() {
        if(this.onlineOffline1) {
            this.userService.getNotification().subscribe((res) => {
                this.notificationList = res;
            }, (err) => {
                console.log(err);
            });
        }
    }

    getUserNotification() {
        if(this.onlineOffline1) {
            this.userService.getUserNotification().subscribe((res) => {
                this.model.notifications = res;
            }, (err) => {
                console.log(err);
            });
        }
    }

    ngOnInit() {
        this.verified = this.route.snapshot.queryParams['verified'];
        this.billingFailedName = "";
        this.billingOccurredName = "";
        this.newSignUpName = "";
        this.playistItemPlayedName = "";
        this.getNotificationList();
        this.getUserNotification();
        this.getUserProfileData();
        // checking if its a new user or not
        if (this.notificationList) {
            if (this.verified) {
                this.billingFailedName = "Billing failed";
                this.billingOccurredName = "Billing occurred";
                this.newSignUpName = "New signup from my referral code";
                this.playistItemPlayedName = "Playlist song played";
            }
        }
        this.scrollService.enableScrollIfDisabled();
        this.blockUI.stop(); // Stop blocking

    }

    setNoification(notification, i, $event) {
        if ($event.checked) {
            this.model.notifications[i] = notification.id;
        } else {
            this.model.notifications[i] = null;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/user/signup/notification/notification.component.ts